import axios from 'axios'

import { ApiResponse, LoketBalancesViewModel, LoketLeaveBalanceResource } from '../../models'
import transformLoketBalancesResource from '../../services/LoketBalances/transformLoketBalancesResource'
import { getLoketBridgeApiUrl } from './loket'

export async function getLoketLeaveBalance(employmentId: string): Promise<LoketBalancesViewModel> {
    const response = await axios
        .get(`${getLoketBridgeApiUrl()}/leave/balance/${employmentId}`) as unknown as ApiResponse<LoketLeaveBalanceResource[]>

    return transformLoketBalancesResource(response.data, employmentId)
}
